<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Config } from '#lib/constants/config.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { preserveGlobalNav } from '#lib/features/navigation/utils/preserveGlobalNav/preserveGlobalNav.js';
	import { NewsletterForm } from '#lib/features/newsletter/components/NewsletterForm/index.js';
	import { page } from '$app/state';
	import { Link } from '$global/components/Link';
	import { showToast } from '$global/components/Toasts';
	import { Txt } from '$global/components/Txt';
	import { getImageUrl } from '$global/utils/getImageUrl';

	interface Props {
		class?: string;
		/** Load the background eagerly at high priority, where the widget is the LCP candidate. */
		priority?: boolean;
		classes?: {
			background?: string;
		};
	}

	let { classes = {}, priority = false, ...rest }: Props = $props();

	const imageSrc = getImageUrl('6dadd7d0-f043-4bb1-9265-53e95463c0d8.jpg');

	// App-webview visitors (global_nav=0) must keep the param on the privacy
	// policy link, otherwise that page renders the global nav they must not see.
	let privacyHref = $derived(
		preserveGlobalNav(GlobalRoutes.PrivacyUs, page.url)
	);
</script>

<div class={twMerge('relative', rest.class)}>
	<!-- Decorative, so empty alt. Lazy by default: the widget is also rendered
	inside hidden feed layouts and below the fold on article pages. -->
	<img
		src={imageSrc}
		class={twMerge('absolute h-full w-full rounded-sm', classes?.background)}
		alt=""
		loading={priority ? 'eager' : 'lazy'}
		fetchpriority={priority ? 'high' : undefined}
		decoding="async"
	/>
	<div class="absolute h-full w-full bg-[black] opacity-10 sm:rounded-sm"></div>
	<div class="flex h-[260px] justify-center px-6 pt-10 pb-12">
		<div class="z-10 flex max-w-[360px] flex-col items-center">
			<img
				src={`${Config.Domain}/img-svelte/heni-art-news-white.png`}
				class="h-9"
				alt="heni art news"
			/>

			<Txt variant="body2" class="text-gray-0 my-4 max-w-[80%] text-center"
				>Get the HENI News Daily Art Digest delivered to your inbox</Txt
			>
			<NewsletterForm
				isHeniNewsletter
				provenance="news-widget"
				onSuccess={() => {
					showToast({
						message: 'You subscribed to HENI Art News',
						variant: 'success',
					});
				}}
				onError={(message) => {
					showToast({ message, variant: 'error' });
				}}
				listId={Config.NewsletterListIds.News}
				variant="light"
				classes={{
					subscribeHelperText: 'text-[#FAFAFA] text-center',
					buttonInputClasses: { success: 'hidden', error: 'hidden' },
				}}
			>
				{#snippet helper()}
					You'll also receive occasional updates about HENI. See our <Link
						class="underline"
						target="_blank"
						rel="noopener noreferrer"
						href={privacyHref}
					>
						Privacy Policy
					</Link>.
				{/snippet}
			</NewsletterForm>
		</div>
	</div>
</div>
